module.exports = __webpack_public_path__ + "static/media/SofaFechado.b4500c7a.png";